import { GcmStatus } from '../../../models/GcmAlerts';

const emptyProgressPercentage = 10;

export const emptyGcmProgressData = [
    {
        color: '#D0D5E0',
        value: 0,
        valueSuffix: 'menu_projects',
        label: 'in_cancellation_en',
        percentage: emptyProgressPercentage,
        status: GcmStatus.InCancellation,
    },
    {
        color: '#D0D5E0',
        value: 0,
        valueSuffix: 'menu_projects',
        label: 'warning_en',
        percentage: emptyProgressPercentage,
        status: GcmStatus.Warning,
    },
    {
        color: '#D0D5E0',
        value: 0,
        valueSuffix: 'menu_projects',
        label: 'issue_en',
        percentage: emptyProgressPercentage,
        status: GcmStatus.Issue,
    },
];

export const emptyGcmChartData = [
    {
        status: GcmStatus.InCancellation,
        title: 'cts_in_cancellation',
        data: {
            labels: [''],
            datasets: [{ label: '', data: [0], borderColor: '#F06D6D', backgroundColor: '#F06D6D', barThickness: 18 }],
        },
        dataList: [],
    },
    {
        status: GcmStatus.Warning,
        title: 'cts_warning',
        data: {
            labels: [''],
            datasets: [{ label: '', data: [0], borderColor: '#FF8C26', backgroundColor: '#FF8C26', barThickness: 18 }],
        },
        dataList: [],
    },
    {
        status: GcmStatus.Issue,
        title: 'cts_active_issues',
        data: {
            labels: [''],
            datasets: [{ label: '', data: [0], borderColor: '#D0DEF8', backgroundColor: '#D0DEF8', barThickness: 18 }],
        },
        dataList: [],
    },
];
